import React, { useState, useRef, useImperativeHandle } from "react";
import { Popconfirm, Tooltip, theme } from "antd";
import { DeleteOutlined, EditOutlined , PlusCircleFilled  } from "@ant-design/icons";
import TSTable from "../../../common/TSTable";
import ColorButton from "../../../common/ColorButton";
import { DELETE } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import AddLatexModal from "../../../components/setting-conponents/ProductType/AddLatexModal";
import { dateTimeToHumanString } from "../../../frameworks/Util";
import ErrorMessages from "../../../common/ErrorMessages";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";

const LatexList = React.forwardRef((props, ref) => {
  const { isDone } = props;
  const [openAddLatexModal, setOpenAddLatexModal] = useState(false);
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages , setErrorMessages]= useState(null);

  const {
    token: { colorWarning, colorError , colorSuccess },
  } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages (error.errorMessages);
      }
    }
  };

  const handleEdit = (record) => {
    if (!record || !record.id) {
      setErrorMessages("ไม่พบข้อมูลที่เหมาะสมสำหรับการแก้ไข");
      return;
    }

    setTarget(record);
    setOpenAddLatexModal(true);
  };

  const handleDelete = async (id) => {
    if (!id) {
      setErrorMessages("ID ไม่ถูกต้อง");
      return;
    }
    setErrorMessages(null);
    try {
      await DELETE(`${URL_SETTING.PRODUCT}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) => isDone ? null : (
        <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
          <Tooltip triger='hover' title="แก้ไขข้อมูล">
            <ColorButton
              type="primary"
              override={colorWarning}
              style={{ margin: 5 }}
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
        </div>
      )
    },
    {
      title: "ชื่อสินค้า (น้ำยางข้น)",
      dataIndex: "name",
      key: "name",
      align: "center",
      searcher : true,
    },
    {
      title: "ชื่อย่อ",
      dataIndex: "short_name",
      key: "short_name",
      searcher : true,
      align: "center",
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      ellipsis: true,
      align: "center",
      render: (value) => dateTimeToHumanString(value),

    },
    {
      title: "วันที่แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      ellipsis: true,
      align: "center",
      render: (value) => dateTimeToHumanString(value),
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        icon={<PlusCircleFilled />}
        style={{ marginBottom: 10 , float: "right" }}
        onClick={() => setOpenAddLatexModal(true)}
      >
        เพิ่มน้ำยางข้น
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={`${URL_SETTING.PRODUCT}?type=concentrate_latex`}
        ref={tableRef}
      />
      <AddLatexModal
        open={openAddLatexModal}
        onClose={() => {
          setOpenAddLatexModal(false);
          setTarget(null);
        }}
        onUpdate={() => { 
          setOpenAddLatexModal(false);
          setTarget(null);
          refreshData(); 
        }}
        target={target}
      />
    </div>
  );
});

export default LatexList;
